import { Icon } from "@iconify/react";
import { Action, CTADropdown } from "../../components/shared/Dropdown";
import {
  ButtonSize,
  IconCTAButton,
  IconPlacement,
  IconSize,
} from "../quickRound/CTAButtonComponents";
import { useAuthStore } from "../../store";
import { useGetCompanyConfig } from "../../queries/termsheet";

export function ExportImport({
  actions,
  onAction,
  text,
}: {
  actions: Action[];
  onAction: (action: Action) => void;
  text?: string;
}) {
  const companyId = useAuthStore((state) => state.companyId) ?? "";
  const { data: companyConfig } = useGetCompanyConfig(companyId);

  if (companyConfig?.preferences?.hideSystemGeneratedReports) {
    return <></>;
  }

  return (
    <CTADropdown
      className="items-center"
      dropdownClassName="bottom-auto"
      actions={actions}
      onAction={onAction}
      render={() => (
        <IconCTAButton
          buttonSize={ButtonSize.SMALL}
          value={text ?? "Export"}
          iconName={"ri:arrow-drop-down-line"}
          iconPlacement={IconPlacement.RIGHT}
          iconSize={IconSize.L}
        />
      )}
    />
  );
}
